import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

const BoxWrapper = styled(Box)(({ theme }) => ({
    width: '100%',
    marginLeft: theme.spacing(5.5),
    '& > *': {
      marginTop: '1rem !important',
      marginRight: '1rem !important',
    }
  }))

export default BoxWrapper